export class MessageParameterQuote {
  subsbribetype: string;
  filter: string;
  delay: string;
  quantidade?: string;
}
